<template lang="pug">
	.multi-select-control(:class="{'change-process': changedValue !== null, [theme]: true, disabled: disabled}")
		.input-title(v-if="title") {{title}}
		.number-input
			label(v-on:wheel="processChangeValueByMouseWheel($event)")
				input.form-control.form-control-sm(:value="getDisplayedValue()" :disabled="true")
			.drop-icon.fa.fa-caret-down(ref="drop-icon" v-on:click="openMenu($event)")
			.open-menu(v-on:click="openMenu($event)")
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	export default {
		name: 'MultiSelect',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {}
		},
		components: {},
		props: ['title','default','value','values','disabled','disabledValue','options','theme'],
		data() {

			this.element = null;

			return {
				showed: true,
				changedValue: null,
				position: {
					right: 0,
					bottom: 0
				}
			};

		},
		mounted() {

		},
		methods: {
			collectData() {

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null && this.changedValue !== undefined) value = this.changedValue;
				else if (this.value !== null && this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			getDisplayedValue() {

				if (this.disabled && this.disabledValue) return this.disabledValue;

				let value = this.getValue();

				if (this.options.displayedValueTransform) return _.map(value, v => this.options.displayedValueTransform(v)).join(', ');

				return value;

			},
			toggleValue(v) {

				this.changedValue = [...this.getValue()];

				if (this.changedValue.includes(v)) this.changedValue = _.without(this.value, v);
				else this.changedValue.push(v);

				this.$emit('change', this.changedValue);

				Broadcast.call("Update MultiSelectDropdown", [this.changedValue]);

				this.update();

			},
			restoreValueType(value) {

				if (!value) value = [];
				else if (!_.isArray(value)) value = [value];

				return value;

			},
			openMenu() {

				if (this.disabled) return;

				Broadcast.call("Show MultiSelectDropdown", [this.$refs["drop-icon"], this.values, {value: this.value, width: this.options.dropdownWidth, height: this.options.dropdownHeight, callback: (data) => {

					this.toggleValue(data.itemValue);

				}}]);

			}
		}

	}
</script>

<style lang="sass">

	.multi-select-control.dark-medium
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		align-items: center
		font-size: 0

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.number-input
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			color: rgba(255, 255, 255, 0.87)
			position: relative
			height: 30px
			border: 1px solid #23282c
			border-radius: 0.25rem
			background: #515b65

			&:focus
				outline: none
				box-shadow: none
				background: #515b65
				border: 1px solid rgba(255, 255, 255, 0.3)

			&:hover
				outline: none
				box-shadow: none
				background: #515b65
				border: 1px solid rgba(255, 255, 255, 0.3)

			label
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin: 0
				padding: 0

			input
				margin: 0
				width: calc(100% - 25px)
				height: 28px
				box-shadow: none
				padding: 0 5px
				margin: 0
				font-size: 14px
				transition: none
				border: none
				background-color: transparent

				&:focus
					outline: none
					box-shadow: none
					background: transparent
					border: none

				&:hover
					outline: none
					box-shadow: none
					background: transparent
					border: none

			.drop-icon
				position: absolute
				width: 25px
				height: 30px
				right: 0
				top: 0
				color: #e4e7ea
				font-size: 14px
				cursor: pointer
				text-align: center

				&:before
					position: absolute
					top: 7px
					right: 7px
					color: rgba(255,255,255,0.2)

			.open-menu
				width: 100%
				height: 100%
				position: absolute
				left: 0
				top: 0
				cursor: pointer

		.number-input:hover

			.drop-icon

				&:before
					color: rgba(255,255,255,0.8)

	.multi-select-control.dark-medium.change-process

		.title
			color: #20a8d8

		.number-input:hover

			.drop-icon

				&:before
					color: rgba(255,255,255,0.8)

	.multi-select-control.dark-medium.disabled
		opacity: 0.4

		.number-input
			border: 1px solid rgba(0,0,0,0.3)

			.drop-icon
				visibility: hidden

			.open-menu
				display: none

		.number-input:hover

			.drop-icon

				&:before
					color: rgba(255,255,255,0.8)

</style>
